var _path, _path2, _rect, _path3, _rect2, _polygon, _rect3, _rect4, _path4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrj3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2880 1600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2214,963.66h317.06s0-931.04,0-931.04h-226.48s0,843.19,0,843.19h-90.58s0,87.84,0,87.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1675.9,32.62h-374.84c-40.51,0-73.65,10.13-73.65,22.5v528.44c0,12.38,33.14,22.5,73.65,22.5h374.84c40.51,0,73.65-10.13,73.65-22.5V55.13c0-12.38-33.14-22.5-73.65-22.5ZM1511.15,433.02c0,2.46-6.59,4.48-14.65,4.48h-16.04c-8.06,0-14.65-2.01-14.65-4.48v-227.34c0-2.46,6.59-4.48,14.65-4.48h16.04c8.06,0,14.65,2.01,14.65,4.48v227.34Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1226.75,
    y: 508.42,
    width: 239.06,
    height: 456
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2136.04,32h-307.06c-33.18,0-60.34,10.13-60.34,22.5v528.36c0,12.38,27.15,22.5,60.34,22.5h307.06c33.18,0,60.34-10.13,60.34-22.5V54.5c0-12.38-27.15-22.5-60.34-22.5ZM2001.08,432.34c0,2.46-5.4,4.48-12,4.48h-13.14c-6.6,0-12-2.01-12-4.48v-227.31c0-2.46,5.4-4.48,12-4.48h13.14c6.6,0,12,2.01,12,4.48v227.31Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1768.65,
    y: 449.61,
    width: 182.3,
    height: 514.05
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "2196.38 964.42 2014.08 964.42 1910.49 606.12 2092.79 606.12 2196.38 964.42"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2214,
    y: 32,
    width: 385.56,
    height: 87.84
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2617.18,
    y: 739.03,
    width: 227.24,
    height: 227.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M470.03,964.42H103.94c-39.56,0-71.94,10.66-71.94,23.69v556.21c0,13.03,32.37,23.69,71.94,23.69h366.09c39.56,0,71.94-10.66,71.94-23.69v-556.21c0-13.03-32.37-23.69-71.94-23.69ZM309.12,1385.85c0,2.59-6.44,4.71-14.31,4.71h-15.66c-7.87,0-14.31-2.12-14.31-4.71v-239.29c0-2.59,6.44-4.71,14.31-4.71h15.66c7.87,0,14.31,2.12,14.31,4.71v239.29Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 569.68,
    y: 964.42,
    width: 551.86,
    height: 196.38
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 569.68,
    y: 1371.62,
    width: 551.86,
    height: 196.38
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 569.68,
    y: 1168.95,
    width: 551.86,
    height: 196.38
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 825.67,
    y: 966.27,
    width: 295.87,
    height: 601.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrj3);
export default __webpack_public_path__ + "static/media/prj_3.0e07179fdd454c5313348306fdf65f55.svg";
export { ForwardRef as ReactComponent };